import { render, staticRenderFns } from "./FunPuzzle.vue?vue&type=template&id=22ece37a&scoped=true"
import script from "./FunPuzzle.vue?vue&type=script&setup=true&lang=js"
export * from "./FunPuzzle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FunPuzzle.vue?vue&type=style&index=0&id=22ece37a&prod&scoped=true&lang=css"
import style1 from "./FunPuzzle.vue?vue&type=style&index=1&id=22ece37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ece37a",
  null
  
)

export default component.exports